import axios from 'axios';
import { ADMIN_API_BASE } from './api_admin';

const _err = (error) => {
  if (error.response) {
    console.error('Admin Auth API error:', error.response.status, error.response.data);
  } else {
    console.error('Admin Auth API error:', error.message);
  }
};

// POST auth/login/   {email, password} -> { success, token, admin }
export const APIAdminLogin = async ({ email, password }) => {
  try {
    const r = await axios.post(
      `${ADMIN_API_BASE}/auth/login/`,
      { email, password },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return r.data;
  } catch (e) { _err(e); throw e; }
};

// POST auth/logout/
export const APIAdminLogout = async (token) => {
  try {
    const r = await axios.post(
      `${ADMIN_API_BASE}/auth/logout/`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return r.data;
  } catch (e) { _err(e); throw e; }
};

// GET auth/me/  -> { success, admin }
export const APIAdminMe = async (token) => {
  try {
    const r = await axios.get(
      `${ADMIN_API_BASE}/auth/me/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return r.data;
  } catch (e) { _err(e); throw e; }
};

// POST auth/request-password-reset/  {email}
export const APIAdminRequestPasswordReset = async (email) => {
  try {
    const r = await axios.post(
      `${ADMIN_API_BASE}/auth/request-password-reset/`,
      { email },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return r.data;
  } catch (e) { _err(e); throw e; }
};